import { z } from "zod";

export const PublicationStatus = { DRAFT: "draft", PUBLISHED: "published" } as const;
export const PublicationStatusSchema = z.enum(PublicationStatus);
export type PublicationStatus = z.infer<typeof PublicationStatusSchema>;
